import script from "./Boards.vue?vue&type=script&setup=true&lang=js"
export * from "./Boards.vue?vue&type=script&setup=true&lang=js"

import "./Boards.vue?vue&type=style&index=0&id=736c0447&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-736c0447"]])

export default __exports__